import { toast } from "react-toastify";
import {
  fetchReservationAnalyticsSuccess,
  fetchReservationAnalyticsFailure,
} from "./reducer";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { GET_RESERVATION_ANALYTICS_API } from "../../constants/constants";
import { setSuccessMessage } from "../../toastMessage/action";
import { getCurrentWeekRange } from "../../../Components/Utils/UtilityFunctions";

export const getReservationAnalytics =
  (setLoading, dateRange) => async (dispatch) => {
    setLoading(true);
    if (!dateRange) {
      dateRange = getCurrentWeekRange();
    }
    await determineBaseUrlAndPerformApiCall(
      `${GET_RESERVATION_ANALYTICS_API}?period=3m&heatmapFrom=${dateRange?.from}&heatmapTo=${dateRange?.to}`,
      "GET"
    )
      .then((response) => {
        setLoading(false);
        if (!response.error) {
          dispatch(fetchReservationAnalyticsSuccess(response || {}));
          // dispatch(setSuccessMessage(true));
        }
        if (response.error) {
          if (response.error.code === "NotFound") {
            dispatch(fetchReservationAnalyticsSuccess({}));
          } else {
            dispatch(fetchReservationAnalyticsFailure(response.error.message));
            toast.error(`${response.error.message}`);
          }
        }
      })
      .catch((errorResp) => {});
  };
